import { Injectable } from "@angular/core";
import { AuthProvider } from "../auth/auth";
import { AppConfig } from "../../config/app.config";
import { Customer } from "../../models/customer";
import { DataProvider } from "../data/data";
import { URLSearchParams } from "@angular/http";

const ROUTE = 'customers';

@Injectable()
export class AccountProvider extends DataProvider<Customer>{

    constructor() {
        super(ROUTE);
    }

    /**
     * Retrieves account details of current user from the database.
     */
    public async getAccount(): Promise<Customer> {
        return this.auth.get(ROUTE).then(x => x as Customer);
    }

    /**
     * Updates the account details in the database.
     * @param account Account details of current user
     */
    public async updateAccount(account: Customer): Promise<boolean> {
        var form = new URLSearchParams();
        form.append('phonenumber', account.contact_details.phone);
        form.append('mailaddress', account.contact_details.mail);
        return this.auth.put(`contactdetails/${account.contact_details.uuid}`, form).then(x => x != null);
    }
}


// WEBPACK FOOTER //
// ./src/providers/account/account.ts